module.exports = __webpack_public_path__ + "img/4.4528d6e8.png";